import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import MainTable from 'components/managementTables/mainTable'
import IconTile from 'components/managementDashboard/IconTile'
import FinanceDataFourth from 'components/managementTables/daneFinansoweFourth';
import Spinner from 'components/common/Spinner';
import Select from "react-select";
import {getMainTable, getCodeMain, getFinanceTable} from 'actions/pulpitActions'
import {getOpkNumbers, getOpkFull} from 'actions/filterOpkActions';
import ModuleNavbar from 'components/Navbars/ModuleNavbar'
import DonutChartManagement from'components/managementDashboard/DonutChart'
import BarChartManagement from'components/managementDashboard/BarChart'
import HorizontalBarChartManagement from'components/managementDashboard/HorizontalBarChart'

// reactstrap components
import {
    Button,
    FormGroup,
    Form,
    Input,
    Label,
    Row,
    Col,
    Card,
    CardBody, CardHeader, CardTitle, ButtonGroup
} from "reactstrap";
import moment from "moment";
import ReactDatetime from "react-datetime";
import DatePicker from "react-datepicker";

const ManagementDashboardPage = (props) => {
    const {
        getMainTable, loadingMain, mainTable, errorMain, getCodeMain,
        getOpkNumbers, OpkNumbers, OpkNumbersLoading,
        getOpkFull, OpkFull, OpkFullLoading,
        getFinanceTable, financeTable, loadingFinance, errorFinance
    } = props
    const [dateFrom, setDateFrom] = useState("")
    const [dateBefore, setDateBefore] = useState("")
    const tableData = []
    const [opkSelect, setOpkSelect] = React.useState({value: "", label: "Wybierz numer OPK"})
    const optionsOPK = []
    const [func, setFunc] = useState(false);

    const displayFunction = (e) => {
        setFunc(!func);
    }
    // if(!OpkFullLoading) OpkFull.forEach(opk => {optionsOPK.push({value:opk, label:opk})})
    if (!OpkFullLoading) Object.entries(OpkFull).map(([key, value], id) => {
        optionsOPK.push({value: key, label: key +' '+ value })
    })

    React.useEffect(() => {
        const opk = localStorage.getItem("activeOPKforManagement")
        const opkName = localStorage.getItem("activeOPKforManagementName")
        localStorage.removeItem("activeOPKforManagementName")
        if (opk !== '' && opk !== undefined && opk !== null) {
            setOpkSelect({
                value: opk,
                label: opk + ' [' + opkName + ']'
            }, localStorage.removeItem("activeOPKforManagement"))
            // localStorage.removeItem("activeOPKforManagement")
        }

        getMainTable()
        // getOpkNumbers()
        getOpkFull()
        // eslint-disable-next-line
    }, [])
    React.useEffect(() => {
        changeOPK()
    }, [opkSelect])
    const changeOPK = () => {
        let nr = opkSelect.label
        if (nr && nr !== "Wybierz numer OPK") {
            nr = nr.split(' ')[0];
        }
        else return;
        let params = {
            number: nr,
            datebefore: moment(dateBefore).format("YYYY-MM"),
            dateafter: moment(dateFrom).format("YYYY-MM")
        }
        if (!dateBefore) params['datebefore'] = ""
        if (!dateFrom) params['dateafter'] = ""
        getFinanceTable(params)
    }
     const changeMainWindow = () => {
        // let nr = opkSelect.label
        // if (nr && nr !== "wybierz numer") {
        //     nr = nr.split('[')[1].split(']')[0];
        // }
        // else return;
        let params = {
            datebefore: moment(dateBefore).format("YYYY-MM"),
            dateafter: moment(dateFrom).format("YYYY-MM")
        }
        if (!dateBefore) params['datebefore'] = ""
        if (!dateFrom) params['dateafter'] = ""
        getMainTable(params)
    }
    const [refresh, setRefresh] = React.useState(false)
    React.useEffect(() => {
        setRefresh(!refresh)
    }, [loadingMain])
    //empty {} for each report
    const [showOPK, setShowOPK] = React.useState({})
    const showOPKtoggle = (opk) => {
        let temp = showOPK
        if (showOPK[opk] !== undefined) { //if that opk was clicked before, toggle view on that row
            temp[opk] = !showOPK[opk]
            setShowOPK(temp)
            setRefresh(!refresh)
        } else { //first time for that opk -> get children from API
            let params = {
                'number': opk,
                datebefore: moment(dateBefore).format("YYYY-MM"),
                dateafter: moment(dateFrom).format("YYYY-MM")
            }
            if (!dateBefore) params['datebefore'] = ""
            if (!dateFrom) params['dateafter'] = ""
            getCodeMain(params)
            temp[opk] = true
            setShowOPK(temp)
            setRefresh(!refresh)
        }
    }
    const customStyles = {
        control: (base) => ({
            ...base,
            border: 'px solid black',
            // This line disable the blue border
            // boxShadow: 'none'
        })

    }
    useEffect(() => {
        changeOPK();
        changeMainWindow();
        setParamDates()
    },[dateFrom,dateBefore])

    const [dates, setDates] = useState({datebefore: '', dateafter: ''})
    const setParamDates = () => {
        //not fast enough for using it in this component
        let params = {
            datebefore: moment(dateBefore).format("YYYY-MM"),
            dateafter: moment(dateFrom).format("YYYY-MM")
        }
        if (!dateBefore) params['datebefore'] = ""
        if (!dateFrom) params['dateafter'] = ""
        setDates(params)
    }

    const valueConvert = (val) => {
        if(typeof val === typeof 1) return Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
        return ''
    }
    const statValueConvert = (val, item) => {
        let prec=0
        if(item === '% wykorzystania łóżek'||item === 'Średni czas pobytu w dniach') prec = 2
        let value = val
        if(val&&typeof value === typeof 1){
          value = value.toFixed(prec).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
        }
        if(item === '% wykorzystania łóżek') value+='%'
        return value
      }

    const [rowWidth, setRowWidth] = React.useState({})
    useEffect(() => {
        if(!loadingFinance) setRowWidth(checkRowWidth())
    },[loadingFinance])

    const checkRowWidth = () => {
        let secondColumn = false
        if(financeTable!==undefined){
            let stat = ["Liczba łóżek","Liczba hospitalizowanych pacjentów","Liczba wykonanych osobodni","% wykorzystania łóżek","Średni czas pobytu w dniach", 
            'Liczba wykonanych porad', 'Liczba wykonanych procedur medycznych', 'Liczba wykonanych usług']
            stat.every((item, i)=>{
                if(financeTable[item]!==undefined){
                    if(financeTable[item]!==0){ secondColumn = true; return false }}
                    return true
            })
            let finans =["Średni jednostkowy koszt całkowity osobodnia","Koszt osobodnia opieki","Średni jednostkowy koszt porady"]
            finans.every((item, i)=>{
                if(financeTable[item]!==undefined){
                    if(financeTable[item]!==0){ secondColumn = true; return false }}
                    return true
            })
        }else{ secondColumn = true }

        return secondColumn?5:6
    }

    const longerTable = (table) => {
        let newData = {}
        Object.keys(table).forEach(item => {
            newData[item] = table[item]
            newData[item+'_1'] = table[item]
            newData[item+'_2'] = table[item]
        })
        return newData
    }

    const checkFinanse = () => {
        if(loadingFinance) return false
        if(errorFinance !== null) return false
        if(financeTable == undefined) return false
        if(Object.getOwnPropertyNames(financeTable).length == 0) return false
        else return true
    }

    return (
        <div className="content">
            <ModuleNavbar title='Pulpit Zarządczy' icon='nc-icon nc-briefcase-24' page={29}
                        //   gradient='linear-gradient(rgb(255, 252, 63) 0%, rgb(250, 190, 0) 70%)' 
                          color='rgb(73, 88, 176)' func={displayFunction}/>
            {!func && <> <Row>
                <Col className="ml-auto mr-auto" ms="12">
                    <Card>
                        <CardBody>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <ReactDatetime
                                            inputProps={{
                                                className: "form-control okr",
                                                placeholder: "data początkowa",
                                                'aria-label': "data początkowa",
                                            }}
                                            dateFormat={"YYYY-MM"}
                                            timeFormat={false}
                                            locale="pl"
                                            onChange={(date) => {
                                                setDateFrom(date, setShowOPK({}))
                                            }}
                                            value={dateFrom}
                                            className='dateSelectPulpit'
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <ReactDatetime
                                            inputProps={{
                                                className: "form-control okr",
                                                placeholder: "data końcowa",
                                                'aria-label': "data końcowa",
                                            }}
                                            dateFormat={"YYYY-MM"}
                                            timeFormat={false}
                                            locale="pl"
                                            onChange={(date) => {
                                                setDateBefore(date, setShowOPK({}))
                                            }}
                                            value={dateBefore}
                                            className='dateSelectPulpit'
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    {mainTable&&Object.getOwnPropertyNames(mainTable).length !== 1?<>
                        <Row>
                            <Col>
                                <IconTile name='Koszty - wartość ogółem' value={valueConvert(mainTable['Wartość ogółem']['Koszt własny sprzedaży'])+' zł'} 
                                    icon='fas fa-money-bill-alt' color={{icon:'pulpit', text: 'black'}} cardStyle={{height: '90%'}}/>
                            </Col>
                            <Col>
                                <IconTile name='Przychody - wartość ogółem' value={valueConvert(mainTable['Wartość ogółem']['Przychód całkowity'])+' zł'} 
                                    icon='fas fa-money-bill-alt' color={{icon:'pulpit', text: 'black'}} cardStyle={{height: '90%'}} />
                            </Col>
                            <Col>
                                <IconTile name='Wynik finansowy' value={valueConvert(mainTable['Wartość ogółem']['Wynik finansowy'])+' zł'} 
                                    icon='fas fa-credit-card' color={{icon:'pulpit', text: mainTable['Wartość ogółem']['Wynik finansowy']<0?'chartRed':'success'}} cardStyle={{height: '90%'}} />
                            </Col>
                            <Col>
                                <IconTile name='% pokrycia kosztów przychodami' value={valueConvert(mainTable['Wartość ogółem']['% pokrycia kosztów przychodami'])+'%'} 
                                    icon='fas fa-percent' color={{icon:'pulpit', text: 'black'}} cardStyle={{height: '90%'}} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md='6'>
                                <Card>
                                    <CardBody>
                                        {/* <p className="card-category text-md text ">Koszt własny sprzedaży oraz przychód całkowity [zł]</p> */}
                                        <HorizontalBarChartManagement 
                                            opkSelect={opkSelect} 
                                            dataChart={mainTable} 
                                            dataNames={["Koszt własny sprzedaży", "Przychód całkowity"]} />
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md='6'>
                                <Card>
                                    <CardBody>
                                        {/* <p className="card-category text-md text ">Wynik finansowy [zł]</p> */}
                                        <HorizontalBarChartManagement 
                                            opkSelect={opkSelect} 
                                            dataChart={mainTable} 
                                            dataNames={["Wynik finansowy"]} />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col md='12'>
                                            <MainTable tableData={mainTable} showOPK={showOPK} showOPKtoggle={showOPKtoggle} dateBefore={dateBefore} dateFrom={dateFrom}
                                                    refresh={refresh}/> 
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </>: <>
                        {errorMain !== null ? <>Nie udało się pobrać danych</>:<>
                            {loadingMain ? <Spinner></Spinner>:<Card className='text-center'><CardBody>Brak danych dla wybranego okresu</CardBody></Card>} 
                        </>}
                    </>}
                </Col></Row>

                <Row>
                    <Col className="ml-auto mr-auto" ms="12">
                        <Card>
                            <CardBody>
                                {/* Panel menedżerski dla kierownika */}

                                <Row className='text-center '>
                                    <Col md="12" sm="12" className='ml-auto mr-auto'>
                                        <FormGroup>
                                            {/* <h5><strong><label>Wybierz numer OPK </label></strong></h5> */}
                                            <Select
                                                className="nowaOkr text-left select-pulpit"
                                                classNamePrefix="react-select"
                                                name="opkSelect"
                                                value={opkSelect}
                                                onChange={(value) => {
                                                    setOpkSelect(value);
                                                }}
                                                options={optionsOPK}
                                                placeholder="Wybierz numer OPK"
                                                aria-label="Wybierz numer OPK"
                                                styles={customStyles}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        {opkSelect.value !== "" && <> {checkFinanse() ? <>
                            <Row>
                                <Col>
                                    <IconTile name='Koszt własny sprzedaży OPK' value={valueConvert(financeTable['Koszt własny sprzedaży'])+' zł'} 
                                        icon='fas fa-money-bill-alt' color={{icon:'pulpit', text: 'black'}} cardStyle={{height: '90%'}}/>
                                </Col>
                                <Col>
                                    <IconTile name='Przychody całkowite OPK' value={valueConvert(financeTable['Przychód całkowity'])+' zł'} 
                                        icon='fas fa-money-bill-alt' color={{icon:'pulpit', text: 'black'}} cardStyle={{height: '90%'}} />
                                </Col>
                                <Col>
                                    <IconTile name='Wynik finansowy' value={valueConvert(financeTable['Wynik finansowy'])+' zł'} 
                                        icon='fas fa-credit-card' color={{icon:'pulpit', text: financeTable['Wynik finansowy']<0?'chartRed':'success'}} cardStyle={{height: '90%'}} />
                                </Col>
                                <Col>
                                    <IconTile name='% pokrycia kosztów przychodami' value={valueConvert(financeTable['% pokrycia kosztów przychodami'])+'%'} 
                                        icon='fas fa-percent' color={{icon:'pulpit', text: 'black'}} cardStyle={{height: '90%'}} />
                                </Col>
                                <Col>
                                    <IconTile name='% wykonania kontraktu z&nbsp;NFZ' value={valueConvert(financeTable['% wykonania kontraktu z NFZ'])+'%'} 
                                        icon='fas fa-percent' color={{icon:'pulpit', text: 'black'}} cardStyle={{height: '90%'}} />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={rowWidth}>
                                    <Card>
                                        <CardBody>
                                            <p className="card-category text-md text ">Rodzaje kosztów</p>
                                            <BarChartManagement opkSelect={opkSelect} dataChart={financeTable}></BarChartManagement>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={rowWidth}>
                                    <Card>
                                        <CardBody>
                                            <p className="card-category text-md text ">Struktura kosztów</p>
                                            <DonutChartManagement opkSelect={opkSelect} dataChart={financeTable}></DonutChartManagement>
                                        </CardBody>
                                    </Card>
                                </Col>
                                {financeTable!==null &&
                                <Col >
                                    {["Liczba łóżek","Liczba hospitalizowanych pacjentów","Liczba wykonanych osobodni","% wykorzystania łóżek","Średni czas pobytu w dniach", 
                                        'Liczba wykonanych porad', 'Liczba wykonanych procedur medycznych', 'Liczba wykonanych usług'].map((item, i)=>{
                                            if(financeTable[item]!==undefined){
                                                if(financeTable[item]!==0){
                                                return (
                                                    <Card className="card-stats" key={`dane_statystyczne_${i}`}>
                                                        <CardBody>
                                                            <Row>
                                                                <Col className="numbers">
                                                                    <p className="card-category grid-top" style={{textTransform: 'none'}}>{item}</p>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col className="numbers">
                                                                    <CardTitle tag="p" className="no-wrap">{statValueConvert(financeTable[item], item)}</CardTitle>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                    // <IconTile name={item} value={statValueConvert(financeTable[item], item)} key={`dane_statystyczne_${i}`}
                                                    //     icon='far fa-chart-bar' color={{icon:'gray', text: 'black'}} />
                                              )}}
                                    })}
                                    {rowWidth!=6 && <hr/>}
                                    {["Średni jednostkowy koszt całkowity osobodnia","Koszt osobodnia opieki","Średni jednostkowy koszt porady"].map((item, i)=>{
                                        if(financeTable[item]!==undefined){
                                            if(financeTable[item]!==0){
                                            return (
                                                <Card className="card-stats" key={`dane_finansowe_${i}`}>
                                                        <CardBody>
                                                            <Row>
                                                                <Col className="numbers ">
                                                                    <p className="card-category grid-top" style={{textTransform: 'none'}}>{item}</p>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col className="numbers">
                                                                    <CardTitle tag="p" className="no-wrap">{valueConvert(financeTable[item])+' zł'}</CardTitle>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                // <IconTile name={item} value={valueConvert(financeTable[item])+'zł'} key={`dane_finansowe_${i}`}
                                                //     icon='far fa-hospital' color={{icon:'pulpit', text: 'black'}} />
                                          )}}
                                    })}
                                </Col>}
                            </Row>
                            <Row>
                                <Col>
                                    <Card>
                                        <CardBody>
                                            <FinanceDataFourth opkSelect={opkSelect} tableData={financeTable} dates={dates}></FinanceDataFourth>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </>:<>
                            {errorFinance !== null ? <>Wystąpił błąd podczas pobierania danych</>:<>
                                {loadingFinance ? 
                                    <Spinner></Spinner>:
                                    <Card className='text-center'>
                                        <CardBody>
                                            Brak danych dla wybranego opk w wybranym okresie
                                        </CardBody>
                                    </Card>} 
                            </>}
                        </>}</>}
                    </Col>
                </Row> </>}

            {func && <>
                <Card>
                    <CardHeader>
                        <CardTitle tag="h5">
                            Drogi Użytkowniku,
                        </CardTitle>
                    </CardHeader>
                    <CardBody style={{textAlign: 'justify', lineHeight: '2', fontSize: '14px'}}>
                    w&nbsp;module <span className='text-pulpit'>„Pulpit zarządczy”</span> masz możliwość jednoczesnej prezentacji danych z&nbsp;wielu źródeł, co&nbsp;pozwala 
                    na&nbsp;analizę danych, ocenę bieżącej sytuacji finansowej podmiotu oraz podejmowanie właściwych decyzji zarządczych.
                    Aby uzyskać informację o&nbsp;kosztach i&nbsp;przychodach podmiotu:
                    <ul>
                        <li>wybierz właściwy zakres czasowy,</li>
                        <li>w&nbsp;celu uzyskania informacji analitycznej na&nbsp;poziomie konkretnych OPK, rozwiń kod syntetyczny klikając w&nbsp;niego (pojawi&nbsp;się lista 
                            wszystkich OPK w&nbsp;danej grupie).</li>
                    </ul>
                    W&nbsp;części analitycznej modułu masz możliwość dokładnej analizy wybranego Ośrodka Powstawania Kosztów. W&nbsp;tym celu wybierz z&nbsp;listy intersujący&nbsp;Cię&nbsp;OPK.
                    Uzyskasz wówczas dane:
                    <ol>
                        <li>finansowe:
                            <ul>
                                <li>wartość kosztu własnego OPK, wartość przychodów, wynik finansowy, %&nbsp;pokrycia kosztów przychodami, %&nbsp;wykonania kontraktu z&nbsp;NFZ,</li>
                                <li>wartość kosztów wg&nbsp;klasyfikacji: koszty stałe i&nbsp;zmienne,</li>
                                <li>średni jednostkowy koszt świadczenia: porady/osobodnia i&nbsp;hospitalizacji,</li>
                                <li>wartość kosztów w&nbsp;ujęciu analitycznym w&nbsp;kategoriach: koszty bezpośrednie, koszty pośrednie działalności medycznej, koszty pośrednie działalności niemedycznej.</li>
                            </ul>
                        </li>
                        <li>statystyczne:
                            <ul>
                                <li>liczba wykonanych świadczeń: porad/procedur medycznych/hospitalizacji i&nbsp;osobodni;</li>
                                <li>liczba łóżek,</li>
                                <li>%&nbsp;wykorzystania łóżek,</li>
                                <li>średni czas pobytu pacjenta w&nbsp;dniach.</li>
                            </ul>
                        </li>
                    </ol><br/>
                    Aby pobrać dostępne w panelu tabele,
                        kliknij w&nbsp;przycisk 
                            <ButtonGroup className='my-0 mx-2'>
                                <Button className="btn-round m-0" color='pulpit' outline type="button" size="sm">
                                .doc
                                </Button>
                                <Button className="btn-round m-0" color='pulpit' outline type="button" size="sm">
                                .csv
                                </Button>
                                <Button className="btn-round m-0" color='pulpit' outline type="button" size="sm">
                                .xlsx
                                </Button>
                            </ButtonGroup>.<br/>
                    <strong> Uwaga! </strong>Pobrane tabele w postaci .xlsx domyślnie zawierają dane w formacie tekstowym. Aby zmienić na format liczbowy należy zaznaczyć dane z kolumny, następnie wybrać
                        zakładkę <i>Dane-{">"}Tekst jako kolumny-{">"}Zakończ</i> lub jeśli bo zaznaczeniu danych pojawia się ikona błędu z wykrzyknikiem należy kliknąć na ikonę i wybrać konwersję do liczb.
                        Pobranie tabeli w postaci CSV zapewnia poprawny format danych.<br/><br/>
                        <Button className="btn-round" outline color="pulpit" onClick={() => {
                            window.focus();
                            window.scrollTo(0, 0);
                            displayFunction('main');
                        }} style={{float: "right", margin: "0px !important"}}> Powrót </Button>
                    </CardBody>
                </Card>
            </>}
        </div>

    )
}

const mapStateToProps = state => ({
    mainTable: state.pulpitReducer.mainTable,
    loadingMain: state.pulpitReducer.loadingMain,
    errorMain: state.pulpitReducer.errorMain,
    OpkNumbers: state.filterOPKReducer.OpkNumbers,
    OpkNumbersLoading: state.filterOPKReducer.OpkNumbersLoading,
    financeTable: state.pulpitReducer.financeTable,
    loadingFinance: state.pulpitReducer.loadingFinance,
    errorFinance: state.pulpitReducer.errorFinance,
    OpkFull: state.filterOPKReducer.OpkFull,
    OpkFullLoading: state.filterOPKReducer.OpkFullLoading,
})
export default connect(mapStateToProps, {
    getMainTable,
    getCodeMain,
    getOpkNumbers,
    getOpkFull,
    getFinanceTable
})(ManagementDashboardPage)